import './src/utils/fontawesome'
import './src/styles/tailwind.css'
import './src/styles/index.css'
import SmoothScroll from 'smooth-scroll'
import 'typeface-roboto'


export const onRouteUpdate = () => {
  new SmoothScroll('a[href*="#"]', {
    duration: 350,
    speedAsDuration: true,
    offset: 30,
    updateURL: false,
  })
}

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `هناك تحديث جديد في الموقع. ` +
      `يمكنك تحديث الصفحة لتنزيل التحديثات الجديدة.`
  )
  if (answer === true) {
    window.location.reload()
  }
}
